export default __webpack_public_path__ + "static/media/flow_2.7088f7b7.jpg";